import React from 'react';
const CalcCartHead = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("colgroup", null,
            React.createElement("col", { width: "4%" }),
            React.createElement("col", { width: "55" }),
            React.createElement("col", { width: "8.5%" }),
            React.createElement("col", { width: "8.5%" }),
            React.createElement("col", { width: "13.5%" }),
            React.createElement("col", { width: "10.5%" })),
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, "\u2116"),
                React.createElement("th", null, "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435"),
                React.createElement("th", null,
                    "\u043C",
                    React.createElement("sup", null, "2")),
                React.createElement("th", null, "\u20BD"),
                React.createElement("th", null, "\u0448\u0442."),
                React.createElement("th", null, "\u0421\u0443\u043C\u043C\u0430")))));
};
export default CalcCartHead;
